import type { CateringAccess } from '../../services/cateringAccessPermissions';

export type { CateringAccess };

export const CACC = {
  LOAD_REQUEST: 'cateringAccess/LOAD_REQUEST',
  LOAD_DONE: 'cateringAccess/LOAD_DONE',
} as const;

/** The signed-in employee's Catering permissions; 'idle' until first read. */
export interface CateringAccessState extends CateringAccess {
  status: 'idle' | 'loading' | 'ready';
}
